import React from 'react';
import { resolveIcon } from '../../components/common/IconResolver';
import type { ViewContext } from '../StubPage';

export interface ViewShellProps {
  context?: ViewContext;
  title?: string;
  icon?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

const ViewShell: React.FC<ViewShellProps> = ({
  context,
  title,
  icon,
  subtitle,
  actions,
  children,
}) => {
  const resolvedTitle =
    title || context?.stubMetadata?.title || context?.itemLabel || 'View';
  const resolvedIcon = icon || context?.stubMetadata?.icon || 'layout-dashboard';
  const parentLabel = context?.groupLabel;
  const itemLabel = context?.itemLabel;

  return (
    <div style={{ padding: '24px' }}>
      {/* Breadcrumb */}
      {parentLabel && (
        <div
          style={{
            fontSize: '13px',
            color: 'var(--text-secondary, #94a3b8)',
            marginBottom: '16px',
            letterSpacing: '0.3px',
          }}
        >
          {parentLabel} &rarr; {itemLabel || resolvedTitle}
        </div>
      )}

      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          marginBottom: '24px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: 'var(--radius-lg, 12px)',
              background: 'var(--accent-primary-muted, rgba(124, 58, 237, 0.1))',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--accent-primary, #7c3aed)',
              flexShrink: 0,
            }}
          >
            {resolveIcon(resolvedIcon, 24)}
          </div>
          <div>
            <h2
              style={{
                fontSize: '20px',
                fontWeight: 600,
                color: 'var(--text-primary, #e2e8f0)',
                margin: 0,
                lineHeight: 1.3,
              }}
            >
              {resolvedTitle}
            </h2>
            {subtitle && (
              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--text-secondary, #94a3b8)',
                  margin: '2px 0 0 0',
                }}
              >
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {actions && <div style={{ display: 'flex', gap: '8px' }}>{actions}</div>}
      </div>

      {/* Content */}
      {children}
    </div>
  );
};

export default ViewShell;
